import { BaseFormatEvent } from '../base-format-event.model';

export class ImpressionSentEvent extends BaseFormatEvent {
  constructor() {
    super('impressionSent');
  }
}
